import { errorHandler } from 'school-space-client/errors';

const config = {
    apiKey: process.env.REACT_APP_BUGSNAG_API_KEY,
    releaseStage: process.env.REACT_APP_DEPLOYMENT_ENV
};

const start = () => {
    errorHandler.createClient(config);
};

export default { start, service: errorHandler };
